import React, {useEffect, useState} from "react";
import {Document, Page, pdfjs} from "react-pdf";
import API from "../../adapters/API";


export default function AllPages(props) {
    const [numPages, setNumPages] = useState(null);


    function onDocumentLoadSuccess({numPages}) {
        setNumPages(numPages);
    }

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    console.log(props.pdfBlob)
    return (

        <div id={'pdf_wrapper'} style={{overflowY: "auto"}}>
            {
                <Document
                    file={props.pdfBlob}
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    {Array.from(
                        new Array(numPages),
                        (el, index) => (
                            <Page
                                loading={""}
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                width={props.browserWidth-15}
                            />
                        ),
                    )}
                </Document>}

        </div>
    );
}
